import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{@text}}\n",{ moduleName: "uplisting-frontend/components/ui/power-select/trigger/empty/index.hbs" })